export default __webpack_public_path__ + "static/media/incorrect21.854b4978.mp3";